import { useTitle } from "../../../contexts/TitleContext";

export  const LayoutTitle = () => {
    const { title } = useTitle();
    
    return (
        <div className="layout-title">{title}</div>
    );
}